import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { bindActionCreators as bindScopedActionCreators } from 'multireducer';
import { connect } from 'react-redux';
import * as outcomePickerActions from "../store/OutcomePicker/actions.js";
import * as searchActions from "../store/search/actions.js";
import { getOutcomePickerState, anyOutcomeSelected } from "../store/OutcomePicker/selectors.js";
import ConnectedOutcomePicker from "./ConnectedOutcomePicker.js";
import OutcomePickerModal from "../components/OutcomePickerModal/index.js";
function mapStateToProps(state, ownProps) {
  var scope = ownProps.scope;
  return {
    outcomePicker: ConnectedOutcomePicker,
    outcomePickerState: getOutcomePickerState(state, scope),
    anyOutcomeSelected: anyOutcomeSelected(state, scope)
  };
}
function mapDispatchToProps(dispatch, ownProps) {
  return _objectSpread(_objectSpread({}, bindScopedActionCreators(outcomePickerActions, dispatch, ownProps.scope)), bindScopedActionCreators(searchActions, dispatch, ownProps.scope));
}
export default connect(mapStateToProps, mapDispatchToProps)(OutcomePickerModal);